import { Cliente } from '@/models'

export type DestinatarioDaVenda = {
	cliente: Cliente | null
	cpfDoCliente: string | null
}

/**
 * Define o destinatário da venda/nota ao importar uma pré-venda.
 *
 * Quando a pré-venda informa um cliente, ele é o destinatário, mesmo que a tela
 * já tenha outro CPF/CNPJ digitado. Quando a pré-venda não informa cliente, o
 * destinatário já informado na tela é preservado (importar a pré-venda não pode
 * apagar o que o operador digitou).
 */
export function resolverDestinatarioDaPreVenda(
	clienteDaPreVenda: Cliente | null,
	cpfOuCnpjDaPreVenda: string | null,
	destinatarioDaTela: DestinatarioDaVenda | null,
): DestinatarioDaVenda {
	if (clienteDaPreVenda) {
		return {
			cliente: clienteDaPreVenda,
			cpfDoCliente: cpfOuCnpjDaPreVenda || clienteDaPreVenda.cnpjOuCpf || '',
		}
	}

	return {
		cliente: destinatarioDaTela?.cliente ?? null,
		cpfDoCliente: destinatarioDaTela?.cpfDoCliente ?? '',
	}
}
